import React from 'react'
import { Box, Container, Grid, Typography, } from '@mui/material';
import { useState } from 'react';
import axios from 'axios';
import { API_URL, APP_URL } from '../../Config';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';

const Trendingcollectors = () => {
    const [collector ,setcollector]=useState("");

    const fetchcollector= async()=>{

        return await axios.get(`${API_URL}/indexData.php?type=creator`, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }).then(res => {
             if(res.data){
               setcollector(res.data);
            }
        })
    }

    useEffect(()=>{
        fetchcollector();
    },[])
    return ( 
        <Box className="Collectors_nft">
            <Container maxWidth='xl'>
                <Typography variant='h2' fontSize='30px' fontWeight='bold' color='#000'>Trending Collectors</Typography>
                <Typography variant='h2' fontSize='16px' fontWeight='300' color='#000' paddingBottom='30px'> Fine art collectors are in a upward this week</Typography>
                <Grid container spacing={1}>
                    {collector && collector.map((data, index) => (
                        <Grid key={index} item lg={3} sm={6} md={6} xs={12} marginBottom='30px'>
                            <Box className='Collectorsmalesuada'>
                                <Box paddingY='10px' display='flex' justifyContent='space-between'>
                                    <Box>
                                        <Link to={`./Profile/${data.Useraddress}`}><img src={APP_URL+ data.Userimage}/></Link> 
                                    </Box>
                                    <Box className='boost_sec'>
                                        <Typography fontWeight='600' variant='h4' fontSize='20px' color='#000'>
                                        <Link to={`./Profile/${data.Useraddress}`}> {data.Username} </Link>
                                        </Typography>
                                        <Typography fontWeight='400' variant='h5' fontSize='14px' color='#666'>
                                            {data.totalNfts} item 
                                        </Typography>
                                    </Box>
                                    <Box>
                                        <Typography fontWeight='600' variant='h6' fontSize='30px' color='#8f8f8f'>
                                            {index +1}
                                        </Typography>
                                    </Box>
                                </Box> 
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Box> 
    )
}

export default Trendingcollectors;   